// extracted by mini-css-extract-plugin
export default {"card":"FrameManager_card__fv78M","badge":"FrameManager_badge__qzIPO","text":"FrameManager_text__udYLN"};